(() => {
  const items = document.querySelectorAll('.cr-reveal, .cr-stagger');

  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -40px 0px'
  });

  items.forEach((item) => observer.observe(item));

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.cr-reveal, .cr-stagger').forEach((item) => {
      item.classList.add('is-visible');
    });
  });
})();
